import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "./AlumniPlaced.css";

import { useDispatch, useSelector } from "react-redux";
import { AllAlumniPlace } from "../../../features/admin/common/Slice";
import { IDS } from "../../../utils/IDS";

const AlumniPlaced = () => {
  const dispatch = useDispatch();

  const alumniplace = useSelector(
    (state) => state.common.all_alumni_place
  );

  useEffect(() => {
    dispatch(AllAlumniPlace());
  }, [dispatch]);

  // ✅ Duplicate data for smooth loop
  const companies = alumniplace
    ? [...alumniplace, ...alumniplace]
    : [];

  // ✅ Prevent render before data
  if (!companies.length) return null;

  return (
    <section className="alumni-placed-section">
      <Container>
        <h2 className="alumni-title">
          2200+ Alumni <span>Placed at</span>
        </h2>

        <Swiper
          key={companies.length} // ✅ Fix refresh issue
          modules={[Autoplay]}
          slidesPerView="auto" // ✅ Important for marquee
          spaceBetween={24}
          loop={true}
          speed={5000}
          allowTouchMove={false}
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
            reverseDirection: true,
            pauseOnMouseEnter: false,
          }}
          className="my_swiper_holder marquee_swiper"
        >
          {companies.map((src, index) => (
            <SwiperSlide key={index} style={{ width: "160px" }}>
              <div className="company-logo">
                <img
                  src={`${IDS.IMG_URL}${src.image}`}
                  alt={`company-${index}`}
                  className="company_logo"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </Container>
    </section>
  );
};

export default AlumniPlaced;